<template>
    <svg
        v-if="logo"
        :class="['brandLogo', className]"
        :viewBox="logo.viewBox"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMidYMid meet"
        role="img"
        :aria-label="normalizedBrand"
    >
        <path
            v-for="(path, index) in logo.paths"
            :key="index"
            :d="path"
            fill="currentColor"
        />
    </svg>
</template>

<script>
    import { brandLogos } from "@/libraries/brandLogos";

    export default {
        name: "BrandLogo",

        props: {
            brand: {
                type: String,
                required: true,
            },

            className: {
                type: String,
                default: "",
            },
        },

        computed: {
            normalizedBrand() {
                return (this.brand || "").trim().toLowerCase();
            },

            logo() {
                return brandLogos[this.normalizedBrand] ?? null;
            },
        },
    };
</script>
